<template>
  <v-card flat>
    <v-card-subtitle class="py-0 text-overline">
      Manage workspaces
    </v-card-subtitle>
    <v-card-title class="pt-0">
      <div>Workspaces</div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <span v-on="on" v-bind="attrs">
            <v-btn
              :disabled="workspaceSharedNumberMaxReached"
              icon
              large
              outlined
              color="secondary"
              class="mx-3"
              @click="workspaceSharedAdd"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </span>
        </template>
        <span v-if="workspaceSharedNumberMaxReached">
          Sorry, you have reached the maximum number ({{
            userLogged.usageLimits.workspacesSharedNumberMax
          }}) of shared workspaces allowed by your current plan; contact us to extend this limit
        </span>
        <span v-else>
          Add a new shared workspace
        </span>
      </v-tooltip>
    </v-card-title>
    <v-progress-linear :active="loadingData" indeterminate color="secondary"></v-progress-linear>

    <v-card-text>
      <!-- <sl-progress v-show="loadingData"></sl-progress> -->
      <v-container v-show="!loadingData" fluid class="pa-0">
        <v-row align="start" justify="start" no-gutter>
          <v-col v-for="workspace in workspaceCollection" :key="workspace.id" md="12">
            <!-------------------------->
            <workspace-card :workspace="workspace" :userAccess="workspace.accessType" />
            <!-------------------------->
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Logger from '@/lib/Logger'

import User from '@/models/User'
import Workspace from '@/models/Workspace'

import WorkspaceCard from '@/components/WorkspaceCard'
// import SlProgress from '@/components/SlProgress'

export default {
  components: {
    WorkspaceCard,
    // SlProgress,
  },

  data() {
    return {
      //
      loadingData: true,
      workspaceCollection: [
        // {
        //   id: '2',
        //   title: 'Invited1',
        // },
        // {
        //   id: '3',
        //   title: 'Invited2',
        // },
      ],
      /* workspaceDeleteDialogShow: false,
      workspaceDeleteCandidate: {}, */
    }
  },

  computed: {
    //
    workspaceSharedNumberMaxReached() {
      return !this.userLogged?.actionsAllowed?.workspaceSharedCreate
    },
    ...mapState(['userLogged']),
  },

  created() {
    Logger.debug('AccountWorkspaces::created()')
    this.queries = [
      User.find({
        get: `{
                id,
                wsAccesses {
                  workspace {
                    id,
                    name,
                    actionsAllowed {
                      userInvite
                    },
                  }
                  accessType
                }
              }`,
        by: { id: this.userLogged.id },
        onChange: data => {
          this.workspaceCollection = data.wsAccesses.map(i => {
            i.workspace.accessType = i.accessType
            return i.workspace
          })
          this.loadingData = false
        },
        onError: error => {
          Logger.error('ERROR in loading data:', error)
          this.toastSet({
            message: 'Error in loading data',
            color: 'error',
          })
        },
      }),
    ]
  },

  mounted() {
    this.errorsDataAccessAllSetFalse()
    this.nodeCurrentSet({})
  },

  beforeDestroy() {
    this.queries.forEach(q => q.destroy())
  },

  methods: {
    workspaceSharedAdd() {
      Workspace.addNew({ name: 'New workspace' }) //NB: ho usato spazi speciali no-break
    },
    ...mapMutations(['nodeCurrentSet', 'toastSet', 'errorsDataAccessAllSetFalse']),
  },
}
</script>
